import { useEffect, useState } from 'react';

function verifyRedirect() {
  if (typeof window === 'undefined') {
    return null;
  }

  const currentSearch = window.location.search;

  return currentSearch;
}

const E2OpenPage = () => {
  const [pathURL, setPathURL] = useState(null);

  useEffect(() => {
    const searchInfo = verifyRedirect();
    if (searchInfo) {
      setPathURL('/link/' + searchInfo);
      window.location.href = pathURL;
    } else {
      window.location.href = '/link/';
    }
  }, [pathURL]);
  return <div />;
};

export default E2OpenPage;
